module.exports = __webpack_public_path__ + "24330d7bcdc15e96ee196ff7f4d26da8.png";